import { useAppSelector } from "app/hooks"
import { FoodInFitVersion } from "./hooks"

const getNativeAppPaywallUrl = (version: FoodInFitVersion) => {
  return version === "v1"
    ? import.meta.env.VITE_NATIVE_APP_PAYWALL_URL_V1
    : import.meta.env.VITE_NATIVE_APP_PAYWALL_URL_V2
}

const useNativeAppPaywallUrl = () => {
  const foodInFitVersion = useAppSelector(
    (state) => state.notification.foodInFitVersion,
  )

  return getNativeAppPaywallUrl(foodInFitVersion)
}

export default useNativeAppPaywallUrl
